import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../utils/auth';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const ResetPasswordPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState(location.state?.email || '');
  const [otp, setOtp] = useState('');
  // No new password required in this flow
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    // Ensure we have an email from the forgot password flow
    if (!email) {
      navigate('/forgot-password');
    }
  }, [email, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (!email || !otp) {
      setError('Email and OTP are required');
      return;
    }
    try {
      setIsLoading(true);
      const base = API_BASE_URL.replace(/\/$/, '');
      // Just verify OTP, then redirect to dashboard (auto-login via token)
      const res = await fetch(`${base}/api/auth/verify-otp`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, otp }),
      });
      if (!res.ok) {
        const data = await res.json().catch(() => ({}));
        throw new Error(data.message || 'Failed to verify OTP');
      }
      const responseData = await res.json();
      // Store account info if present
      if (responseData.accountId) {
        localStorage.setItem('tenantId', responseData.accountId);
      } else if (responseData.accountName) {
        localStorage.setItem('tenantId', responseData.accountName);
      }
      // Use token from backend to log in
      if (responseData.access_token) {
        login(responseData.access_token, {
          email: responseData.email || email,
          name: responseData.accountName || (responseData.email ? responseData.email.split('@')[0] : 'User')
        });
      } else {
        // Fallback minimal flags
        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('token', 'otp-verified-token');
        localStorage.setItem('user', JSON.stringify({ email }));
      }
      navigate('/dashboard');
    } catch (e) {
      setError(e.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Verify OTP</h1>
          <p className="text-muted">Enter the OTP sent to your email</p>
          {email && (
            <p className="text-muted" style={{ marginTop: 4 }}>
              Email: <strong>{email}</strong>
            </p>
          )}
        </div>
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <input type="email" className="form-input" value={email} onChange={(e) => setEmail(e.target.value)} disabled />
          </div>
          <div className="form-group">
            <label className="form-label">OTP</label>
            <input 
              type="text" 
              className="form-input" 
              value={otp} 
              onChange={(e) => setOtp(e.target.value)} 
              placeholder="6-digit code" 
              maxLength={6}
            />
          </div>
          {/* No new password fields in this simplified flow */}
          {error && <div className="error-message">{error}</div>}
          {message && <div className="secure-notice">{message}</div>}
          <button type="submit" className={`btn btn-primary btn-block ${isLoading ? 'loading' : ''}`} disabled={isLoading}>
            {isLoading ? 'Verifying...' : 'Verify OTP'}
          </button>
          <button type="button" className="btn btn-secondary btn-block" style={{ marginTop: 12 }} onClick={() => navigate('/login')}>
            Back to Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPasswordPage;


